package com.dotdrives.web.pages.settings

import com.dotdrives.controller.SettingsTab

fun settingsSectionHash(tab: SettingsTab): String = "#/settings/" + when (tab) {
    SettingsTab.UsersRoles -> "users"
    SettingsTab.Process -> "process"
    SettingsTab.Targets -> "targets"
    SettingsTab.GoalsBudgets -> "goals"
    SettingsTab.Tags -> "tags"
    SettingsTab.Integrations -> "integrations"
    SettingsTab.Billing -> "billing"
}

/** Exact path matching avoids treating arbitrary query values as section routes. */
fun settingsSectionFromHash(hash: String): SettingsTab {
    val path = com.dotdrives.web.parseOrganizationRoute(hash).resourceHash.removePrefix("#").substringBefore('?').trimEnd('/')
    if (path == "/settings" && hash.substringAfter('?', "").split('&').any { it.startsWith("qbo=") })
        return SettingsTab.Integrations
    if (path in setOf("/settings/targets", "/settings/goals-budgets", "/settings/budgets")) return SettingsTab.GoalsBudgets
    return SettingsTab.entries.firstOrNull { settingsSectionHash(it).removePrefix("#") == path }
        ?: SettingsTab.UsersRoles
}
